if (!customElements.get('pf-brand-story')) {
  customElements.define('pf-brand-story', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-product-story') && !this.dataset.placed) {
        const product = document.querySelector('.pf-product-page');
        const anchor = product?.querySelector('.pf-section-nav');
        const wrapper = this.closest('.shopify-section');
        if (anchor && wrapper) {
          this.dataset.placed = 'true';
          product.querySelectorAll('.pf-section-nav, .pf-features-section, .pf-video-section').forEach(el => { el.hidden = true; el.style.display = 'none'; });
          anchor.before(wrapper);
          return;
        }
      }
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const sizeMedia = () => this.style.setProperty('--pfr-viewport', `${document.documentElement.clientWidth}px`);
      sizeMedia();
      window.addEventListener('resize', sizeMedia, options);
      this.querySelectorAll('[data-carousel]').forEach(carousel => {
        const track = carousel.querySelector('.pfr-carousel-track');
        const slides = [...track.children];
        const previous = carousel.querySelector('[data-prev]');
        const next = carousel.querySelector('[data-next]');
        const counter = carousel.querySelector('[data-counter]');
        const selectors = [...carousel.querySelectorAll('[data-slide]')];
        let active = 0;
        const position = slide => slide.offsetLeft - slides[0].offsetLeft;
        const refresh = () => {
          active = slides.reduce((best, slide, i) => Math.abs(position(slide) - track.scrollLeft) < Math.abs(position(slides[best]) - track.scrollLeft) ? i : best, 0);
          if (previous) previous.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
          if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
          selectors.forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
        };
        const go = index => track.scrollTo({ left: position(slides[Math.max(0, Math.min(slides.length - 1, index))]), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        previous?.addEventListener('click', () => go(active - 1), options);
        next?.addEventListener('click', () => go(active + 1), options);
        selectors.forEach((button, i) => button.addEventListener('click', () => go(i), options));
        track.addEventListener('scroll', refresh, { ...options, passive: true });
        window.addEventListener('resize', refresh, options);
        track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(active + (event.key === 'ArrowRight' ? 1 : -1)); }
        }, options);
        carousel.addEventListener('shopify:block:select', event => {
          const index = slides.findIndex(slide => slide.contains(event.target));
          if (index >= 0) go(index);
        }, options);
        refresh();
      });
      this.querySelectorAll('.pfr-lifestyle').forEach(group => {
        const cards = [...group.children];
        const select = card => cards.forEach(item => { item.classList.toggle('is-active', item === card); item.setAttribute('aria-expanded', String(item === card)); });
        cards.forEach(card => {
          card.addEventListener('click', () => select(card), options);
          card.addEventListener('focus', () => select(card), options);
          card.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') select(card); }, options);
        });
      });
      const videos = [...this.querySelectorAll('video[data-autoplay]')];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const visible = new Set();
      const playVisible = () => {
        videos.forEach(video => {
          if (!video.hasAttribute('data-guide') && visible.has(video) && !document.hidden && !reducedMotion.matches && !video.dataset.userPaused) {
            video.muted = true;
            video.play().catch(() => {});
          } else if (!video.paused && (!video.hasAttribute('data-guide') || !visible.has(video) || document.hidden)) {
            video.dataset.autoPaused = 'true';
            video.pause();
          }
        });
      };
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        playVisible();
      }, { threshold: 0.25 });
      videos.forEach(video => {
        video.muted = true;
        const toggle = video.parentElement.querySelector('.pfr-video-toggle');
        const updateToggle = () => { if (toggle) { toggle.textContent = video.paused ? 'Play' : 'Pause'; toggle.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video'); } };
        toggle?.addEventListener('click', () => { if (video.paused) video.play().catch(() => {}); else video.pause(); }, options);
        video.addEventListener('pause', () => {
          updateToggle();
          if (video.dataset.autoPaused) delete video.dataset.autoPaused;
          else video.dataset.userPaused = 'true';
        }, options);
        video.addEventListener('play', () => { delete video.dataset.userPaused; updateToggle(); }, options);
        this.observer.observe(video);
      });
      document.addEventListener('visibilitychange', playVisible, options);
      reducedMotion.addEventListener('change', playVisible, options);
      document.addEventListener('shopify:block:select', event => {
        const block = this.querySelector(`[data-shopify-editor-block*='"id":"${CSS.escape(event.detail.blockId)}"']`);
        const disclosure = block?.closest('details');
        if (disclosure) disclosure.open = true;
      }, options);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
